import Impression from '~/app/components-nds/common/impression'
import React from 'react'
import { getYaNative } from '@yanolja-org/ya-native'
import { isNative } from '~/app/utils/typeguards'
import { sendKinesisClickLogTimeoutAfter } from '~/app/utils/timeout'

type BenefitBannerProps = {
  imageUrl: string
  action: {
    web: string
    app: string
  }
  onImpressed?: () => void
  onClickLog?: () => void | Promise<void>
}

/**
 * 공통 > 베네핏 배너
 * - action 에 따라 페이지 이동처리 로직 포함
 * - 클릭 로그(onClickLog)는 이동 "전"에 전송한다.
 *   Safari 에서 외부 도메인으로 이동하면 이동 후 실행되는 로그 fetch 가 abort 되기 때문이다. (YAWEB-667)
 *   `sendKinesisClickLogTimeoutAfter` 로 Safari 에서는 최대 500ms 만 대기하며,
 *   로그 전송이 실패/지연되어도 try/catch 로 이동은 항상 보장한다.
 */
const BenefitBanner = ({ imageUrl, action, onImpressed, onClickLog }: BenefitBannerProps) => {
  const onClick = async () => {
    try {
      await sendKinesisClickLogTimeoutAfter(() => onClickLog?.())
    } catch {
      // 로그 전송 실패는 무시하고 이동을 진행한다.
    }

    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.deepLink({ link: action.app })
    } else {
      window.location.href = action.web
    }
  }

  return (
    <Impression onImpressed={onImpressed}>
      <div className="mx-auto w-full bg-transparent">
        <div
          role="button"
          aria-label="Benefit banner"
          onClick={onClick}
          className="h-60 w-full cursor-pointer rounded-12 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
      </div>
    </Impression>
  )
}

export default BenefitBanner
